import { render, staticRenderFns } from "./RandomIzation.vue?vue&type=template&id=925c8c4c&scoped=true&"
import script from "./RandomIzation.vue?vue&type=script&lang=js&"
export * from "./RandomIzation.vue?vue&type=script&lang=js&"
import style0 from "./RandomIzation.vue?vue&type=style&index=0&id=925c8c4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925c8c4c",
  null
  
)

export default component.exports